import Swiper, { A11y, Keyboard } from 'swiper'

const TvgImageGallery = {
  init() {
    document.querySelectorAll<HTMLElement>('[data-tvg-image-gallery]').forEach((gallery) => {
      new Swiper(gallery, {
        modules: [A11y, Keyboard],
        a11y: {
          containerMessage: 'Image gallery',
          slideLabelMessage: '{{index}} of {{slidesLength}}',
        },
        grabCursor: true,
        keyboard: {
          enabled: true,
          onlyInViewport: true,
        },
        resizeObserver: false,
        slidesPerView: 1.15,
        spaceBetween: 16,
        breakpoints: {
          768: {
            slidesPerView: 2.2,
            spaceBetween: 24,
          },
          1024: {
            slidesPerView: 2.7,
            spaceBetween: 24,
          },
        },
      })
    })
  },
}

export default TvgImageGallery
